import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
import { isRichContent, toPlainText } from '../../../services/rich-content';
function isContactsSubscribe(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.CONTACTS_SUBSCRIBE && isRichContent(label) && (typeof value === 'boolean' || value === null);
}
function _formatContactsSubscribe(_ref) {
  let {
    field,
    value
  } = _ref;
  if (typeof value !== 'boolean' || value === false) {
    return;
  }
  const label = toPlainText(field.view.label);
  return {
    label,
    value
  };
}
export function formatContactsSubscribe(submission) {
  if (isContactsSubscribe(submission)) {
    return _formatContactsSubscribe(submission);
  }
  return undefined;
}
//# sourceMappingURL=contacts-subscribe-preview.js.map